import { supabase } from '~/lib/supabase';

export async function authHeaders(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { authorization: `Bearer ${token}`, 'content-type': 'application/json' }
               : { 'content-type': 'application/json' };
}

/**
 * POST/PATCH JSON to a Pages Function with the session token attached. Throws
 * on a non-2xx response or an `{ ok: false, error }` body. Used by the write
 * paths that route through `functions/api/*` (service role) instead of writing
 * to RLS-protected tables directly from the browser.
 */
export async function apiSend<T = unknown>(
  path: string,
  method: 'POST' | 'PATCH' | 'PUT' | 'DELETE',
  body?: unknown,
): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: await authHeaders(),
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  let json: unknown = null;
  try { json = await res.json(); } catch { /* non-JSON */ }
  const j = json as { ok?: boolean; error?: string; message?: string } | null;
  if (j?.error === 'read_only') {
    throw new Error(j.message || 'Read-only dashboard mode — CRM editing is disabled.');
  }
  if (!res.ok || (j && j.ok === false)) {
    throw new Error(j?.error || `${method} ${path} failed (${res.status})`);
  }
  return json as T;
}
